// Dashboard and in-app links frequently target <turbo-frame id="content">. When a request
// results in an un-framed response (such as an auth redirect to sign-in or a full-page layout
// render), Turbo's default is to paint "Content missing" into the frame, leaving the user on a
// dead shell. Visit the response as a whole page instead.
//
// The response is passed to visit() rather than its URL so Turbo renders the HTML it already
// fetched. Re-requesting the page would consume single-use flash notices on a response nobody sees.
export function handleFrameMissing(event) {
  const { response, visit } = event.detail;
  event.preventDefault();
  visit(response);
}

export function registerFrameMissingHandler(target = document) {
  target.addEventListener("turbo:frame-missing", handleFrameMissing);
}
